import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { FaEdit, FaTrash, FaPlay } from "react-icons/fa";
import CommonSpinner from '../../../services/commonSpinner';
import { postAdminFileWithToken, getaxiosadminRequestWithToken, deleteAdminAxiosRequestWithoutToken } from '../../../api/api';
import { showToast } from "../../../services/toastifyservices";
import { handleSession } from "../../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { MultiSelect } from "react-multi-select-component";
import endpoints from "../../../api/EndPoints";

const PromotionalVideo = () => {
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [videoName, setVideoName] = useState("");
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [status, setstatus] = useState("");
    const [Editlocations, setEditLocation] = useState([]);

    const [btnLoading, setBtnLoading] = useState(false);
    const [isNew, setIsNew] = useState(true);
    const [selectedRow, setSelectedRow] = useState('');
    const [editUploadVideo, setEditUploadVideo] = useState('');
    const [errors, setErrors] = useState({ videoName: "", selectedVideo: "", locations: "" });
    const navigate = useNavigate();
    const [videoRecords, setVideoRecords] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);


    useEffect(() => {
        fetchVideos();
    }, []);

    const fetchVideos = async () => {
        try {
            setLoading(true);
            const response = await getaxiosadminRequestWithToken(endpoints.FetchPromotionalVideo);
            if (response.success) {
                setVideoRecords(response.data.videos || []);
            }
        } catch (error) {
            showToast('error', error.response?.data.message);
            handleSession(error.response?.data, navigate);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchLocations();
    }, [])

    const fetchLocations = async () => {
  try {
    setLoading(true);
    let page = 1;
    let allLocations = [];
    let hasMore = true;

    while (hasMore) {
      const response = await getaxiosadminRequestWithToken(
        `${endpoints.FetchAddress}?page=${page}`
      );

      if (response?.data?.addresses) {
        const { data, next_page_url } = response.data.addresses;
        const validLocations = (data || []).filter(
          (location) => location.location_id !== null
        );
        allLocations = [...allLocations, ...validLocations];
        if (next_page_url) {
          page++;
        } else {
          hasMore = false;
        }
      } else {
        hasMore = false;
      }
    }
    setLocations(allLocations);
  } catch (error) {
    showToast('error', error.response?.data?.message || 'Error fetching locations');
    handleSession(error.response?.data, navigate);
  } finally {
    setLoading(false);
  }
};


    const handleVideoNameChange = (e) => {
        setVideoName(e.target.value);
        if (errors.videoName) {
            setErrors((prevErrors) => ({ ...prevErrors, videoName: "" }));
        }
    };

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['video/mp4', 'video/webm', 'video/ogg'];
            if (!validTypes.includes(file.type)) {
                showToast("error", "Please select a valid video file (MP4, WebM, or OGG)");
                e.target.value = null;
                return;
            }
            const maxSize = 100 * 1024 * 1024; // 100MB in bytes
            if (file.size > maxSize) {
                showToast("error", "File size should be less than 100MB");
                e.target.value = null;
                return;
            }
        }
        setSelectedVideo(file);
        if (errors.selectedVideo) {
            setErrors((prevErrors) => ({ ...prevErrors, selectedVideo: "" }));
        }
    };

    const resetModal = () => {
        setVideoName("");
        setSelectedVideo(null);
        setstatus("inactive");
        setEditUploadVideo('');
        setErrors({});
    };

    const handleOpenModal = () => {
        setEditUploadVideo('');
        setIsNew(true);
        resetModal();
        setSelectedLocations([]); // ✅ Clear locations
        setEditLocation([]);      // Optional if you use this elsewhere
        setShowModal(true);
    };

    const handleSave = async () => {
        let validationErrors = {};

        if (isNew && !selectedVideo) {
            validationErrors.selectedVideo = "Video is required";
        }

        if (selectedLocations.length === 0) {
        validationErrors.locations = "At least one location is required";
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setBtnLoading(true);
        setErrors({});

        try {
            const formData = new FormData();
            if (selectedLocations.length > 0) {
                selectedLocations.forEach((locationId) => {
                    formData.append("location_ids[]", locationId);
                });
            }
            if (videoName.trim()) {
                formData.append("name", videoName.trim());
            }
            if (!isNew) {
                formData.append("status", status);
                if (selectedVideo) {
                    formData.append("video", selectedVideo, selectedVideo.name);
                }
            } else {
                formData.append("video", selectedVideo, selectedVideo.name);
            }
            const endpoint = isNew ? 'promotional-videos/upload' : `promotional-videos/update/${selectedRow.id}`;
            const response = await postAdminFileWithToken(endpoint, formData);
            showToast("success", response.message);
            setShowModal(false);
            setSelectedLocations([])
            await fetchVideos();
        } catch (error) {
            showToast("error", "Failed to save video");
            // showToast("error", error.response?.data.message || "Failed to save video");
            handleSession(error.response?.data, navigate);
        } finally {
            setBtnLoading(false);
        }
    };

    const handleEdit = (row) => {
        setVideoName(row.name);
        console.log("row", row)
        setstatus(row.status);
        setEditUploadVideo(row.video_path);
        // Filter out "null" or falsy values from location_ids
        const validLocationIds = (row.location_ids || []).filter(id => id && id !== "null");
        setIsNew(false);

        setSelectedLocations(validLocationIds); // this drives MultiSelect
        setEditLocation(validLocationIds); // optional: keep if used elsewhere        setIsNew(false);
        setSelectedRow(row);
        setShowModal(true);
        setSelectedVideo(null);
        setErrors({});
    };

    

    const handleDelete = (row) => {
        Swal.fire({
            title: "Do you want to delete this video?",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            icon: "question",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await deleteAdminAxiosRequestWithoutToken(`promotional-videos/delete/${row.id}`);
                    if (response.success) {
                        debugger
                        showToast("success", response.data.message);
                        await fetchVideos();
                    } else {
                        showToast("error", response.data.message || "Failed to delete the video");
                    }
                } catch (error) {
                    showToast("error", error.response?.data.message);
                }
            }
        });
    };

    const handleWatchVideo = (videoUrl) => {
        window.open(videoUrl, '_blank');
    };

    return (
        <div className="mt-3 p-2 md:p-10 bg-gray-200">
            <div className="card">
                <span className="text-start font-bold ml-4 p-2 headingtext">Promotional Videos</span>
            </div>

            <div className="card">
                <div className='row'>
                    <div className="text-end p-3">
                        <button
                            className="btn btn-primary fw-bold btncolor"
                            onClick={handleOpenModal}
                        >
                            Add New Video
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-container mt-3">
                <table className="table table-striped table-hover">
                    <thead className="table-header table-primary">
                        <tr>
                            <th style={{ width: "5%" }}>Id</th>
                            <th style={{ width: "20%" }}>Video Name</th>
                            <th style={{ width: "10%" }}>Status</th>
                            <th style={{ width: "45%" }}>Adresses</th>
                            <th className="text-end pe-5" style={{ width: "20%" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody className="table-body">
                        {loading ? null : (
                            videoRecords.length > 0 ? (
                                videoRecords.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.id}</td>
                                        <td>{row.name}</td>

                                        <td>
                                            <span className={`badge ${row.status === 'active' ? 'bg-success' : 'bg-danger'} cursor-default`}>
                                                {row.status === 'active' ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>

                                        <td>
                                            {row.addresses && row.addresses.length > 0 ? (
                                                row.addresses.flat().map((location, index, array) => (
                                                    <span key={index}>
                                                        {location.city}
                                                        {index < array.length - 1 && ' , '}
                                                    </span>
                                                ))
                                            ) : (
                                                <span>No location</span>
                                            )}
                                        </td>
                                        <td className="text-end">
                                            <button
                                                onClick={() => handleWatchVideo(row.video_url)}
                                                className="btn btn-sm btn-success me-2"
                                                title="Watch Video"
                                            >
                                                <FaPlay />
                                            </button>
                                            <button
                                                onClick={() => handleEdit(row)}
                                                className="btn btn-sm btn-primary me-2"
                                                title="Edit"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(row)}
                                                className="btn btn-sm btn-danger"
                                                title="Delete"
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No videos available</td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isNew ? 'Add New Video' : 'Edit Video'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Video Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={videoName}
                                onChange={handleVideoNameChange}
                                placeholder="Enter video name"
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Locations</Form.Label>
                            <MultiSelect
                                required
                                options={locations.map((location) => ({
                                    label: location.city,
                                    value: location.location_id,
                                }))}
                                value={selectedLocations
                                    .map((location_id) => {
                                        const loc = locations.find((l) => l.location_id === location_id);
                                        return loc ? { label: loc.city, value: loc.location_id } : null;
                                    })
                                    .filter(Boolean)} // filter out any unmatched
                                onChange={(selected) =>
                                    setSelectedLocations(selected.map((s) => s.value))
                                }
                                labelledBy="Select Location"
                                valueRenderer={(selected) => {
                                    if (selected.length === locations.length) {
                                        return locations.map((loc) => loc.city).join(', ');
                                    } else {
                                        return selected.map((s) => s.label).join(', ');
                                    }
                                }}
                            />

                            {errors.locations && (
                            <div className="invalid-feedback" style={{ display: "block" }}>
                            {errors.locations}
                            </div>
              )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Upload Video</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleVideoChange}
                                accept="video/mp4,video/webm,video/ogg"
                                isInvalid={!!errors.selectedVideo}
                            />
                            <Form.Text className="text-muted">
                                Supported formats: MP4, WebM, OGG (Max size: 100MB)
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {errors.selectedVideo}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {!isNew && (
                            <Form.Select
                                value={status} // Directly bind to the string value
                                onChange={(e) => setstatus(e.target.value)} // Set string value
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Form.Select>
                        )}

                        {editUploadVideo && (
                            <div className="mb-3">
                                <label>Current Video:</label>
                                <video
                                    width="100%"
                                    controls
                                    className="mt-2"
                                    src={editUploadVideo}
                                >
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSave}
                        disabled={btnLoading}
                    >
                        {btnLoading ? (
                            <>
                                <Spinner animation="border" size="sm" /> Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {loading && <CommonSpinner />}
        </div>
    );
};

export default PromotionalVideo;
